import _ from 'lodash';
import useSettingsService from 'components/hooks/useSettingsService';
import { getTeamLevelFilters } from './teamLevel.filters';
import { checkIfIsPmCustomDashboard } from '../custom-report.serivce';
import { getNonEditModeFilters } from './nonEditMode.filters';
import useDoraFeatureFlags from 'views/root/views/home/hooks/useDoraFeatureFlags';

const Filters = ({
  pullRequestLabels,
  report = {},
  filters,
  currentTeams,
  repositories,
  services,
  license,
  isTeamLicense,
  isOnEditMode,
  isCustom,
  isShowContributorDropdown,
  enableRepositoryLevelMetricsSetting = false,
  defaultTeam = {},
  isShowTeamDropdown = true,
  isShowReposDropdown = true,
  isShowAllTeams = true,
  isMultiTeamsAllowed = true,
  retentionDays,
  isShowToggle = true,
  shouldShowTeamOrRepoDropdowns = true,
  shouldShowLabelsDropdown = true,
  metricsFilterByServiceEnabled,
  localIterations,
  isUncheckDefault,
  setIsUncheckDefault
} = {}) => {
  const { getSettingOrDefinitionValue } = useSettingsService();

  const isPmCustomDashboard = checkIfIsPmCustomDashboard({ report });
  const reportName = _.get(report, 'name');
  const { isAllControbutorsTeamSelected, enableTeamSelection } =
    useDoraFeatureFlags();

  const filtersForTeamLevel = getTeamLevelFilters({
    filters,
    report,
    getSettingOrDefinitionValue,
    metricsFilterByServiceEnabled,
    license,
    isShowTeamDropdown,
    shouldShowTeamOrRepoDropdowns,
    shouldShowLabelsDropdown,
    isShowToggle,
    enableRepositoryLevelMetricsSetting,
    isShowReposDropdown,
    isShowContributorDropdown,
    services,
    isTeamLicense,
    isMultiTeamsAllowed,
    isCustom,
    isShowAllTeams,
    defaultTeam,
    currentTeams,
    repositories,
    isPmCustomDashboard,
    pullRequestLabels,
    localIterations,
    isUncheckDefault,
    setIsUncheckDefault,
    enableTeamSelection,
    isAllControbutorsTeamSelected
  });

  const nonEditModeFilters = getNonEditModeFilters({
    isOnEditMode,
    reportName,
    retentionDays,
    license,
    filters,
    isCustom,
    isPmCustomDashboard,
    isAllControbutorsTeamSelected
  });

  return [...nonEditModeFilters, ...filtersForTeamLevel];
};

export default Filters;
